exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-danger[data-v-1f981ef1]{border:3px solid #da4453!important}@media only screen and (max-width:800px){.marginTR[data-v-1f981ef1]{margin-bottom:1rem}.paddingTD[data-v-1f981ef1]{padding:.5rem}table[data-v-1f981ef1],tbody[data-v-1f981ef1],td[data-v-1f981ef1],th[data-v-1f981ef1],thead[data-v-1f981ef1],tr[data-v-1f981ef1]{display:block}thead tr[data-v-1f981ef1]{position:absolute;top:-9999px;left:-9999px}tr[data-v-1f981ef1]{border:1px solid #ccc}td[data-v-1f981ef1]{border:none;border-bottom:1px solid #eee;position:relative;padding-left:50%;white-space:normal;text-align:left;min-height:2rem}td[data-v-1f981ef1]:before{position:absolute;top:6px;left:6px;width:45%;padding-right:10px;white-space:nowrap;text-align:left;font-weight:700;content:attr(data-title)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f981ef1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Users.vue
// module id = 329
// module chunks = 0